export default "__VITE_ASSET__BXPDh$J1__"